






















import Vue from 'vue'
import { mapGetters } from 'vuex'
import { contentful } from '@neurotrack/web-core'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

type Entry = typeof contentful.ContentEntry

export default Vue.extend({
  name: 'LearnContentDetail',
  props: {
    category: String,
    slug: String
  },
  data() {
    const entry: Entry = {}
    return {
      entry,
      articleLoaded: false,
      lang: this.$i18n.locale
    }
  },
  async beforeMount() {
    const client = contentful.createClient()
    const locale = this.lang === 'en' ? 'en-US' : 'ja'
    const entries = await client.getEntries({
      content_type: 'chpArticle',
      'fields.slug': this.slug,
      locale
    })
    if (entries) {
      this.entry = entries?.items[0] as Entry
      this.articleLoaded = true
    }
  },
  computed: {
    ...mapGetters('content/learn', {
      getCategoryItems: 'getCategoryItems',
      getCategoryText: 'getCategoryText',
      categories: 'getCategories'
    })
  },
  methods: {
    documentToHtmlString
  }
})
